<template>
  <div>
    <List class="sign-record"  v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">

      <div class="sign-record-body">
        <div v-for="(item,index) in List" :key="index" class="sign-item">
          <div class="item-header">
            <div>订单编号：{{item.order_sn}}</div>
            <div class="">{{item.sign_time}}</div>
          </div>
          <div class="item-body" @click="godetail(item)">
            <div class="info">
              <div>{{item.venue}}</div>
              <div>
                <div>报名时间：{{item.sign_time}}</div>
                <div>审核时间：{{item.consign_time}}</div>
                <div v-if="item.pay_time">支付时间：{{item.pay_time}}</div>
                <div>上课地点：{{item.venue}}</div>
              </div>
            </div>
            <div class="r"><van-icon name="arrow" size=".2rem" color="#666666"/></div>
          </div>
          <div class="item-footer">
            <div class="ma">状态：<span class="state-name">{{item.stateName}}</span></div>

            <div class="btn" >
              <!--<div class="mvbutton ">查看详情</div>-->
              <van-button plain type="warning" round class="bdbutton" @click="cancalApplay(item)" v-if="item.order_status<3">取消</van-button>

              <van-button plain type="primary" round class="bdbutton" @click="godetail(item)">详情</van-button>
              <van-button plain type="info" round class="bdbutton" @click="goinvoice(item)" v-if="item.order_status == 3 && !item.invoice">发票</van-button>
            </div>
          </div>
        </div>
      </div>

    </List>
    <van-skeleton avatar :row="1" v-if="List.length==0"/>
    <van-popup
        v-model="show"
        closeable
        round
        position="bottom"
        :style="{ height: '70%' }"
        class="pppp"
    >
      <div class="tt">发票</div>
      <div class="field">
        <div class="f_t">发票抬头</div>
        <van-radio-group v-model="form.type" direction="horizontal">
          <van-radio name="1">个人</van-radio>
          <van-radio name="2">单位</van-radio>
        </van-radio-group>
        <template v-if="form.type == 1">
          <van-field v-model="form.name" label="个人名称" placeholder="请输入名称" />
        </template>
        <template v-else>
          <van-field v-model="form.company" label="单位名称" placeholder="请输入单位名称" />
          <van-field v-model="form.code" label="纳税人识别码" placeholder="请输入纳税人识别码" />
        </template>
      </div>
      <div class="field">
        <div class="f_t">收票人信息</div>
        <van-field v-model="form.mobile" label="收票人手机" placeholder="请输入手机号" />
        <van-field v-model="form.email" label="收票人邮箱" placeholder="请输入邮箱" />
      </div>
      <div class="footer footer-btn">
        <div class="mvbutton" @click="submit">确认</div>
      </div>
    </van-popup>
  </div>


</template>
<script>
    import { Cell, List, Icon, Button, Dialog, Popup, Field, RadioGroup, Radio } from 'vant'
    import './index.less'

    export default {
        name: "sign",
        components: {
          Cell,
          List,
          vanIcon:Icon,
          vanButton:Button,
          Dialog,
          vanPopup:Popup,
          vanField:Field,
          vanRadioGroup:RadioGroup,
          vanRadio:Radio
        },
        data() {
          return {
            page:1,
            List: [],
            finished:false,
            loading:false,
            show:false,
            form:{
              type:'1',
              mobile:'',
              email:'',
              company:'',
              code:'',
              name:''
            },
            id:'',

          }
        },
        methods: {
          submit() {
            this.$api.system.subOder({id:this.id,invoice:JSON.stringify(this.form)}).then((res)=>{
              if (res.code * 1 === 200) {
                this.show= false
                this.page = 1;
                this.finished = false;
                this.getList()
                this.$toast.success('提交成功');
              }
            })
          },
          goinvoice(item) {
            console.log(item)
            this.show = true
            this.id = item.id
          },
          onLoad(){
            this.getList()
          },
          getList() {
              if(this.finished) return;
              this.$api.user.myApply({page:this.page}).then((res) => {
                  if (res.code * 1 === 200) {
                      if(this.page<=1)
                      {
                        this.List = [];
                      }
                      this.List = this.List.concat(res.data.list)
                      if(res.data.page.pageCount>this.page){
                          this.page++
                      }else{
                          this.finished   =   true
                      }
                  }
                  this.loading = false
              })
          },
          cancalApplay(item)
          {
              if(this.loading) return;
              this.loading = false;
              let that=this
              Dialog.confirm({
                  title: '标题',
                  message: '确定要取消报名吗？',
              }).then(() => {
                  that.$api.user.cancalapplay({id:item.id}).then((res) => {
                      if (res.code * 1 === 200) {
                          Dialog.alert({
                              title: '提示',
                              message: res.message,
                          }).then(() => {
                              window.location.reload()
                          });
                      }
                      that.loading = false
                  })
              });
          },
          godetail(val){
            this.$router.push({name:'applydetail',params:{id:val.id}})
          },
        },
        mounted() {
            this.$nextTick(() => {
                // this.getList();
            })
        }
    }
</script>
